<template>
  <div>
    <NavBar :admin="true" :items="items" />
		<v-main>
			<v-container>
        <v-progress-linear indeterminate color="primary" v-if="loading"></v-progress-linear>
        <template v-else>
          <ICDForm :icd="icd" :edit="true" />
        </template>
			</v-container>
		</v-main>
  </div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import ICDForm from "@/components/icd/ICDForm.vue";
import axios from "axios";

export default {
  name: "EditICD",
  components: {
    NavBar,
    ICDForm
  },
  data: () => ({
    loading: false,
    icd: {code: '...'}
  }),
  computed: {
		items() {
			return [
				{
					text: this.$gettext("Dashboard"),
					disabled: false,
					link: true,
					to: "/admin/dashboard"
				},
				{
					text: "ICD-11",
					disabled: false,
          link: true,
          to: "/admin/dashboard/icd"
        },
        {
					text: this.icd.code,
					disabled: true,
					link: true
				}
			];
		}
  },
  created() {
    const icdId = this.$route.params.iid;
    this.loading = true;
    axios
      .get("/icd/" + icdId, {params: {admin: true}})
      .then(response => {
        console.log(response.data);
        this.icd = response.data.disease;
        this.loading = false;
      })
      .catch(error => {
        console.log(error);
        this.loading = false;
      });
  }
}
</script>